<template>
  <div>
    <div class="comm_shut_wrap">
      <div class="inbox">
        <div class="comm_title_wrap">
          <h4>{{ $t('MSG_TIT_NODE_MAPPING') }}</h4>
        </div>
        <sui-grid
          ref="grid0"
          :columns="gridColumns0"
          :dataset="'dsWorkflowNode'"
          :showDisplayCountControl="false"
          :showMoveControl="false"
          :multiselect="true"
        >
          <div class="comp_spacing" />
          <div class="btn_wrapL">
            <sui-button
              type="button"
              class="comm_btn_gridTop"
              @click="onClickRowAdd"
            >
              {{ $t('MSG_BTN_ADD') }}
            </sui-button>
            <sui-button
              v-permission:delete="pageId"
              type="button"
              class="comm_btn_gridTop"
              @click="onClickRowDelete"
            >
              {{ $t('MSG_BTN_DEL') }}
            </sui-button>
            <sui-button
              type="button"
              class="comm_btn_gridTop"
              @click="onClickRowCancel"
            >
              {{ $t('MSG_BTN_CANCEL') }}
            </sui-button>
          </div>
        </sui-grid>
      </div>
      <div class="btnbox" />
      <div class="inbox">
        <div class="comm_title_wrap">
          <h4>{{ $t('MSG_TIT_RLT_SRCH') }}</h4>
        </div>
        <sui-grid
          ref="grid1"
          :columns="gridColumns1"
          :dataset="'dsWorkflowNodeRelation'"
          :showDisplayCountControl="false"
        />
        <div class="comm_btn_wrap">
          <sui-button
            v-permission:read="pageId"
            type="button"
            class="comm_btn_border"
            @click="onClickPreview"
          >
            {{ $t('MSG_BTN_PRVW') }}
          </sui-button>
          <sui-button
            v-permission:update="pageId"
            type="button"
            class="comm_btn_solid"
            @click="onClickSave"
          >
            {{ $t('MSG_BTN_SAVE') }}
          </sui-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00003_T02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    workflowId: {
      type: String,
      default: null,
    },
    workflowNodeInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localdata0: [
      ],
      gridColumns0: [{
        text: this.$t('MSG_TXT_NODE_ID'),
        datafield: 'nodeId',
      }, {
        text: this.$t('MSG_TXT_NODE_NM'),
        datafield: 'nodeName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onClickGridNodeName,
            type: 'link',
          }, this.dsWorkflowNode, this.$refs.grid0);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_ATTRIBUTE'),
        datafield: 'nodeTypeName',
      }, {
        text: this.$t('MSG_TXT_EDIT'),
        datafield: 'buttonName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onClickGridRowEdit,
            type: 'positive',
          }, this.dsWorkflowNode, this.$refs.grid0);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
      localdata1: [],
      gridColumns1: [{
        text: this.$t('MSG_TXT_RLT'),
        datafield: 'relationNodeTypeName',
      }, {
        text: this.$t('MSG_TXT_NODE_ID'),
        datafield: 'relationNodeId',
      }, {
        text: this.$t('MSG_TXT_NODE_NM'),
        datafield: 'nodeName',
      }, {
        text: this.$t('MSG_TXT_RUL_NM'),
        datafield: 'ruleName',
      }],
    };
  },
  computed: {},
  watch: {
    workflowId() {
      if (!utils.isEmpty(this.workflowId)) {
        this.setWorkflowNodeData();
      }
    },
    workflowNodeInfo: {
      deep: true,
      handler() {
        if (!utils.isUndefined(this.workflowNodeInfo)
         && !utils.isEmpty(this.workflowNodeInfo)) {
          if (utils.isEqual(this.workflowNodeInfo.type, 'grid')) {
            this.workflowNodeGridEdit();
          } else {
            this.workflowNodeGridDataAdd();
          }
        }
      },
    },
  },
  mounted() {
    // this.dsWorkflowNode.$on(this.dsWorkflowNode.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);

    this.$nextTick(() => {
      if (!utils.isEmpty(this.workflowId)) {
        this.setWorkflowNodeData();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {
    // this.dsWorkflowNode.$off(this.dsWorkflowNode.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
  },
  methods: {
    /**
     * 워크플로우 노드 매핑 목록 조회
     */
    setWorkflowNodeData() {
      http.request(this.pageId, 'DTS_CMR_00029', {
        path: {
          'workflow-id': this.workflowId,
        },
      }).then(res => {
        const data = utils.clone(res.data);
        data.forEach((itm, index) => {
          data[index].buttonName = this.$t('MSG_BTN_EDIT');
          data[index].workflowNodeParamList = [];
        });
        this.dsWorkflowNode.submit();
        this.dsWorkflowNode.setRawData(data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * 노드 매핑 grid row Selected Event
     */
    // datasetSelectionChanged(data) {
    //   if (utils.size(data.newSelections) > 1) {
    //     utils.pullAllWith(data.newSelections, data.oldSelections, utils.isEqual);
    //   }
    //   if (utils.size(data.newSelections) !== 1) return false;

    //   const { workflowNodeUid } = this.dsWorkflowNode.data[data.newSelections];
    //   if (!utils.isEmpty(workflowNodeUid)) this.setWorkflowNodeRelationData(workflowNodeUid);

    //   return null;
    // },
    /**
     * 노드 매핑 grid row NodeName Click Event
     */
    onClickGridNodeName(event, dataRow) {
      this.setWorkflowNodeRelationData(dataRow.workflowNodeUid);
    },
    /**
     * 노드 매핑 관계 노드 목록 조회
     */
    setWorkflowNodeRelationData(workflowNodeUid) {
      http.request(this.pageId, 'DTS_CMR_00032', {
        path: {
          'workflow-node-uid': workflowNodeUid,
        },
      }).then(res => {
        this.dsWorkflowNodeRelation.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * 저장
     */
    onClickSave() {
      const dataParams = {
        insertWorkflowNodeList: this.dsWorkflowNode.data,
        deleteWorkflowNodeList: this.dsWorkflowNode.getRemovedRows(),
      };

      if (!this.selectedRowCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00033', {
          data: dataParams,
          path: {
            'workflow-id': this.workflowId,
          },
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));

          this.dsWorkflowNodeRelation.submit();
          this.dsWorkflowNode.submit();

          this.setWorkflowNodeData();
        });
      });

      return true;
    },
    /**
     * Grid Button Event
     */
    onClickRowAdd() {
      this.$emit('setPopupProp', 'setWorkflowNodeInfo', {});
      this.$emit('popupCall', 'p03', 'add', '');
    },
    onClickRowDelete() {
      const selectedIndexes = this.dsWorkflowNode.getSelectedIndexes();
      this.dsWorkflowNode.deleteRows(selectedIndexes);
    },
    onClickRowCancel() {
      this.dsWorkflowNode.submit();
      this.dsWorkflowNode.setRawData(this.dsWorkflowNode.originalData);
    },
    /**
     * 행추가 Event CallBack
     * 노드 추가/편집 팝업 callback 함수.
     */
    workflowNodeGridDataAdd() {
      const index = utils.findIndex(this.dsWorkflowNode.data,
        o => utils.isEqual(o.nodeId, this.workflowNodeInfo.nodeId)
       && utils.isEqual(o.nodeTypeCode, this.workflowNodeInfo.nodeTypeCode));

      this.workflowNodeInfo.buttonName = this.$t('MSG_BTN_EDIT');

      if (index < 0) this.dsWorkflowNode.addRows([this.workflowNodeInfo]);
    },
    /**
     * ROW '편집' BUTTON EVENT
     * 노드 추가/편집 팝업 호출.
     */
    onClickGridRowEdit(event, dataRow) {
      this.$emit('setPopupProp', 'setWorkflowNodeInfo', dataRow);
      this.$emit('popupCall', 'p03', 'grid', dataRow['dataset-row-id']);
      return null;
    },
    /**
     * ROW '편집' BUTTON EVENT CALLBACK
     * 노드 추가/편집 팝업 callback 함수.
     */
    workflowNodeGridEdit() {
      const rowIndex = utils.findIndex(this.dsWorkflowNode.data,
        o => utils.isEqual(o['dataset-row-id'], this.workflowNodeInfo.rowId));

      this.dsWorkflowNode.setData(rowIndex, 'nodeId', this.workflowNodeInfo.nodeId);
      this.dsWorkflowNode.setData(rowIndex, 'nodeName', this.workflowNodeInfo.nodeName);
      this.dsWorkflowNode.setData(rowIndex, 'nodeTypeCode', this.workflowNodeInfo.nodeTypeCode);
      this.dsWorkflowNode.setData(rowIndex, 'nodeTypeName', this.workflowNodeInfo.nodeTypeName);
      this.dsWorkflowNode.setData(rowIndex, 'workflowNodeParamList', this.workflowNodeInfo.workflowNodeParamList);
    },
    /**
     * 미리보기 팝업 호출
     */
    onClickPreview() {
      this.$emit('popupCall', 'p02');
    },
    selectedRowCheck() {
      if (utils.isEmpty(utils.trim(this.workflowId))) {
        utils.messageBox('warning', this.$t('MSG_ALT_WKFL_NOT_INFO'));
        return false;
      }
      return true;
    },
  },
  datasets: [{
    id: 'dsWorkflowNode',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'workflowNodeUid', map: 'workflowNodeUid' },
      { type: 'string', name: 'workflowId', map: 'workflowId' },
      { type: 'string', name: 'nodeId', map: 'nodeId' },
      { type: 'string', name: 'nodeName', map: 'nodeName' },
      { type: 'string', name: 'nodeTypeCode', map: 'nodeTypeCode' },
      { type: 'string', name: 'nodeTypeName', map: 'nodeTypeName' },
      { type: 'string', name: 'buttonName', map: 'buttonName' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'pageId', map: 'pageId' },
      { type: 'string', name: 'dataServiceId', map: 'dataServiceId' },
      { type: 'string', name: 'workflowNodeParamList', map: 'workflowNodeParamList' },
    ],
  }, {
    id: 'dsWorkflowNodeRelation',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { type: 'string', name: 'nodeRelationUid', map: 'nodeRelationUid' },
      { type: 'string', name: 'workflowNodeUid', map: 'workflowNodeUid' },
      { type: 'string', name: 'workflowId', map: 'workflowId' },
      { type: 'string', name: 'nodeId', map: 'nodeId' },
      { type: 'string', name: 'nodeName', map: 'nodeName' },
      { type: 'string', name: 'ruleName', map: 'ruleName' },
      { type: 'string', name: 'relationNodeTypeCode', map: 'relationNodeTypeCode' },
      { type: 'string', name: 'relationNodeTypeName', map: 'relationNodeTypeName' },
      { type: 'string', name: 'relationRuleUid', map: 'relationRuleUid' },
      { type: 'string', name: 'relationNodeId', map: 'relationNodeId' }],
  }],
};
</script>
<style scoped>
</style>
